import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';

import { HeaderComponent } from '../header/header.component';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatComponent } from '../chat/chat.component';
import { MembersComponent } from '../members/members.component';
import { UserDataService } from 'src/app/services/userData.service';
import { ApiService } from 'src/app/services/communications/api.service';
import { SignalRService } from 'src/app/services/communications/signalr.service';
import { AssetInfo } from '../../interfaces/AssetInfo';
import { ChatService } from 'src/app/services/chat.service';
import { CallNotificationInfo } from 'src/app/interfaces/call-notifications';
import { MatDialog } from '@angular/material/dialog';
import { CallNotificationComponent } from '../call-notification/call-notification.component';
import { environment } from 'src/environment/environment';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../modal/modal.component';
import { GuestNameAskModalComponent } from '../waitingasset/guest-name-ask-modal/guest-name-ask-modal.component'
import { Title } from '@angular/platform-browser';
import { MatTabsModule } from '@angular/material/tabs';
import { AssistancesComponent } from '../assistances/assistances.component';
import { UserRole } from '../../constants/constants';
import { CommentsComponent } from '../comments/comments.component';


@Component({
  selector: 'app-waitingasset',
  imports: [HeaderComponent, TranslateModule, ChatComponent, MatTabsModule, MembersComponent, AssistancesComponent, CommentsComponent],
  templateUrl: './waitingasset.component.html',
  styleUrls: ['./waitingasset.component.scss']
})

export class WaitingassetComponent implements OnDestroy, AfterViewInit {

  @ViewChild(MembersComponent) membersComponent!: MembersComponent;

  userId: number;
  userName: string;
  error: string = "";
  assetInfo: AssetInfo | null = null;
  isExpert: boolean;

  members = false;
  assistances = false;
  comments = false;
  backgroundImage: string = 'url(assets/images/users/background-technician-none.svg)';
  assistanceState!: number;
  assistancePriority!: number;

  incommingCallDialog: any = null;

  onAssetDeletedSubscription!: Subscription;
  onUpdateParticipantSubscription!: Subscription;
  onCallNotificationSubscription!: Subscription;
  onCallNotificationResponseSubscription!: Subscription;


  constructor(private router: Router, public userDataService: UserDataService, private apiService: ApiService, private signalRService: SignalRService, private chatService: ChatService, public dialog: MatDialog, private route: ActivatedRoute,
    private titleService: Title) {
    this.userId = userDataService.Id!;
    this.userName = userDataService.Name!;
    this.isExpert = userDataService.Role == UserRole.Expert;

    console.log("Waiting asset constructor", this.userId);
  }

  ngAfterViewInit(): void {
    //Comprobar si soy invitado y sacarme el popup
    if (this.userId < 0) {
      console.log("UserName ->" + this.userName);
      if (this.userName == null || this.userName.length == 0)
        this.showGuestAskNameModal();
    }
  }

  ngOnDestroy(): void {
    this.signalREventUnSubscribe();
  }

  ngOnInit(): void {
    console.log("INIT");
    this.route.data.subscribe(data => {
      this.userDataService.assetInfo = data['userData']; // 'userData' es el nombre del resolver en la ruta
      console.log("FROM RESOLVER", this.userDataService);

      if (this.userDataService.assetInfo != undefined) {
        this.updateAssetInfo();
      }
      this.checkParticipants();
      if (this.membersComponent != undefined) this.membersComponent.updateTranscriptionsEnabled(this.userDataService.assetInfo.transcriptionsEnabled);

    });

    this.signalREventSubscribe();
  }

  updateAssetInfo() {
    console.log("UPDATE ASSET INFO: Asset changed update info");
    var title = this.userDataService.assetInfo.parentId == 0 ? this.userDataService.assetInfo.name : this.userDataService.assetInfo.assistances[0].name;
    this.titleService.setTitle(title);
    this.assetInfo = this.userDataService.assetInfo;
    if (this.userDataService.assetInfo.assistances.length > 0) {
      this.assistanceState = this.userDataService.assetInfo.assistances[0].state;
      this.assistancePriority = this.userDataService.assetInfo.assistances[0].priority;
      console.log("ASSISTANCE ID (on init): " + this.userDataService.assetInfo.assistances[0].id, this.assistanceState);
    }

    if (this.membersComponent != undefined) this.membersComponent.updateTranscriptionsEnabled(this.userDataService.assetInfo.transcriptionsEnabled);
  }

  switchMembers(): void {
    this.assistances = false;
    this.comments = false;
    this.members = !this.members;
  }

  switchAssistances(): void {
    this.members = false;
    this.comments = false;
    this.assistances = !this.assistances;
  }

  switchComments(): void {
    this.members = false;
    this.assistances = false;
    this.comments = !this.comments;
  }

  startCall() {
    console.log("startCall");
    this.apiService.startCall(this.userDataService.assetInfo.id!, this.userDataService.Role!).subscribe({
      next: data => {
        console.log("Received call data:" + JSON.stringify(data));
        this.userDataService.otCallToken = data.callToken;
        this.userDataService.otSession = data.session;
        this.userDataService.otApiKey = data.apiKey;
        this.userDataService.CallId = data.callId;

        this.router.navigate(['/call']);
      },
      error: err => {
        // set button to red
        console.log("Error on startCall :" + JSON.stringify(err));

        this.dialog.open(ModalComponent, {
          data: {
            title: 'MODAL.ERROR_TITLE',
            message: 'STARTCALL_ERROR',
            addButtons: false
          }
        });
      }
    });
  }

  signalREventSubscribe() {
    this.onAssetDeletedSubscription = this.signalRService.onAssetDeleted.subscribe(response => {
      console.error("Asset : " + response + " deleted");
    });

    this.onUpdateParticipantSubscription = this.signalRService.onUpdateParticipant.subscribe(() => {
      console.log("** onUpdateParticipant - checkParticipants");
      this.checkParticipants();
    });

    this.onCallNotificationSubscription = this.signalRService.onCallNotification.subscribe((data) => {
      if (data.active) {
        console.log("Call notification received");
        this.openCallNotification(data);
      }
      else
        this.endDialog(data.active);
    });

    this.onCallNotificationResponseSubscription = this.signalRService.onCallNotificationResponse.subscribe((result) => {
      console.log("Call notification response arrived. Call accepted: " + result);
      if (!result.accepted) return;

      this.userDataService.assetInfo.participants.find(user => user.participantId == result.callerId)!.callId = result.callId;
      this.userDataService.assetInfo.participants.find(user => user.participantId == result.participantId)!.callId = result.callId;

      if (this.userDataService.ParticipantId == result.callerId || this.userDataService.ParticipantId == result.participantId) this.startCall();
    });


  }

  checkParticipants() {
    let assetParticipants = this.userDataService.assetInfo?.participants;
    console.log("checkParticipants", assetParticipants);
    if (assetParticipants) {
      this.chatService.assignColorsToParticipants(this.userId); //sólo para el chat
    } else {
      console.log("No asset participants");
    }
  }

  openCallNotification(callNotificationInfo: CallNotificationInfo) {
    console.log("Open call notification dialog");

    let caller = this.userDataService.assetInfo?.participants.find(o => o.participantId == callNotificationInfo.callerId);

    this.incommingCallDialog = this.dialog.open(CallNotificationComponent, {
      panelClass: "callingModal",
      minWidth: '25%',
      data: {
        callerName: caller?.name,
      },
    });


    this.incommingCallDialog!.afterClosed().subscribe((result: boolean) => {
      console.log("After close dialog result: " + result);
      this.sendCallNotificationResult(caller?.participantId!, result);
    });

  }

  endDialog(result: boolean) {
    this.incommingCallDialog!.close(result);
  }

  sendCallNotificationResult(callerId: number, result: boolean) {
    this.apiService.callNotificationResponse(this.userDataService.assetInfo.id!, this.signalRService.getConnectionId()!, callerId, result).subscribe({
      next: () => {
        console.log("Response sent ok: " + result);
      },
      error: err => {
        console.log("Error on sending rejected call:" + JSON.stringify(err));
      }
    });
  }

  signalREventUnSubscribe() {
    console.log("Signal R unsubscrive to events");
    this.onAssetDeletedSubscription.unsubscribe();
    this.onUpdateParticipantSubscription.unsubscribe()
    this.onCallNotificationSubscription.unsubscribe();
    this.onCallNotificationResponseSubscription.unsubscribe();
  }

  showGuestAskNameModal() {
    if (environment.showGuestAskNameModal) {
      const dialogRef = this.dialog.open(GuestNameAskModalComponent, {
        disableClose: true
      });

      // Opcional: manejar el resultado cuando el modal se cierra
      dialogRef.afterClosed().subscribe(userName => {
        console.log('El modal fue cerrado. Result is inputEmail: ', userName);
        this.userDataService.Name = userName;
        this.apiService.updateChatAssetUserName(this.userDataService.assetInfo.id, userName, this.userDataService.ParticipantId!).subscribe({
          next: (result) => {
            console.log("Response sent ok: " + result);
          },
          error: err => {
            console.log("Error on sending rejected call:" + JSON.stringify(err));
          }
        });
      });
    }
  }
}
